export const environment = {
  production: false,
  useHubConnections: true,
  API_URL: "https://testing-maritime-core-api.azurewebsites.net/api",
  HUB_URL: "https://testing-maritime-core-api.azurewebsites.net/realtimeDispatchDashboard",
  HUB_WORKER_URL: "https://testing-maritime-core-api.azurewebsites.net/realtimeWorkersList",
  IDENTITY_URL: "https://testing-maritime-identity-api.azurewebsites.net",
  appVersion: require('../../package.json').version,
};